import { render, staticRenderFns } from "./ConsuntiviExtra.vue?vue&type=template&id=369d7c86&scoped=true&"
import script from "./ConsuntiviExtra.vue?vue&type=script&lang=js&"
export * from "./ConsuntiviExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d7c86",
  null
  
)

export default component.exports